module.exports = __webpack_public_path__ + "img/blue-hair-doc.cc4aa7f6.png";